import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'

export default function useDataTransform(props, data) {
  let contact_methods = useDataValue({
    viewPath: props.viewPath,
    context: 'contact_methods',
  })
  let is_new_calendar_enabled = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_new_calendar_enabled',
  })
  let is_new_generate_letters_enabled = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_new_generate_letters_enabled',
  })

  let appointmentBookingState = useDataValue({
    context: 'event',
    path: 'appointment.booking.state',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let is_schedule_via_sms_or_email_enabled = contact_methods?.some(item =>
      ['phone', 'email'].includes(item.dtype)
    )

    let shouldShowCancelNoShowButton = appointmentBookingState === 'NO_SHOW'

    return [
      { id: 'DELETE', text: 'Delete' },
      { id: 'APPOINTMENT_HISTORY', text: 'Appointment history' },
      { id: 'APPOINTMENT_ADD', text: 'Add appointment after ...' },
      ...(is_new_generate_letters_enabled
        ? [{ id: 'GENERATE_LETTERS', text: 'Generate letters' }]
        : [{ id: 'OLD_GENERATE_LETTERS', text: 'Generate letters' }]),
      ...(shouldShowCancelNoShowButton
        ? [{ id: 'CANCEL_NO_SHOW', text: 'Cancel no show' }]
        : []),
      {
        id: 'MOVE_TO_ANOTHER_TREATMENT',
        text: 'Move to another treatment',
      },
      ...(is_schedule_via_sms_or_email_enabled
        ? [
            {
              id: 'SCHEDULE_VIA_SMS_OR_EMAIL',
              text: 'Schedule via SMS / email',
            },
          ]
        : []),
      ...(is_new_calendar_enabled
        ? [{ id: 'CHANGE_APPOINTMENT_DURATION', text: 'Change duration' }]
        : []),
    ]
  }, [contact_methods, is_new_calendar_enabled, appointmentBookingState])
}
